import React, { useState, useRef } from 'react';
import { bool, object } from 'prop-types';
import { Button, Icon, Tooltip } from '@fiverr-private/fit';
import { s_flag } from '@fiverr-private/icons';
import { LazyComponent } from '@fiverr-private/orca';
import { I18n } from '@fiverr-private/i18n-react';
import { metric } from '@fiverr-private/perseus';
import { BQ_CLICKED_REPORT_GIG } from '../../../../utils/bigQueryEvents';

import './style.scss';

const ReportBtn = ({ isTrustedUser }, { biEvents, logger }) => {
    const [importReportModal, setImportReportModal] = useState(false);
    const openModal = useRef();

    const onReportBtnClick = () => {
        biEvents.sendBigQueryEvent({ eventName: BQ_CLICKED_REPORT_GIG });
        metric.count('report_gig.click');

        if (openModal.current) {
            openModal.current();
        } else {
            setImportReportModal(true);
        }
    };

    const lazyImport = () => import(/* webpackChunkName: 'ReportGig' */ '../ReportModal');

    const onLazyImportError = (error) => {
        logger.error(error, {
            description:'Failed to lazy report gig modal'
        });
    };

    const setOpenModal = (open) => {
        openModal.current = open;
    };

    return (
        <>
            <Tooltip className="report-gig-tooltip"
                containerClassName="report-gig-tooltip-container"
                boxContentClassName="report-gig-tooltip-box"
                content={<I18n k={'gig_page_perseus.top_nav.report_gig.titles.tooltip'}/>}>
                <Button className="btn-report-gig" onClick={onReportBtnClick}>
                    <Icon className="report-gig-icon">{s_flag}</Icon>
                </Button>
            </Tooltip>
            <LazyComponent lazyImport={lazyImport}
                shouldImport={importReportModal}
                onError={onLazyImportError}
                componentProps={{ trigger: setOpenModal, isTrustedUser }}/>
        </>
    );
};

ReportBtn.propTypes = {
    isTrustedUser: bool
};

ReportBtn.contextTypes = {
    biEvents: object,
    logger: object
};

export default ReportBtn;
